(function (CFShippingNoticeMobile) {
  const initPPDMods = () => {
    (function CF26f() {
      function addContent() {
        let details = $('.pdp__container .pdp__product .pdp__product-column:nth-child(2)');
        if (details.length == 0) {
          setTimeout(addContent, 100);
          return;
        }

        $('.pdp__container .pdp__product .pdp__form .product-submit-wrapper').after(
          $(
            `<div class='cf26-shipping-container'><div class='cf26-shipping'>Ships within<span class='cf26-hours'>&nbsp;24 Hours</span></div></div>`
          )
        );
      }

      $(document).ready(function () {
        addContent();
      });
    })();
  };

  const listenForLoaded = () => {
    addEventListener('DOMContentLoaded', (event) => {
      initPPDMods();
    });
  };

  // Public / Init
  CFShippingNoticeMobile.init = function () {
    listenForLoaded();
  };
})((window.CFShippingNoticeMobile = window.CFShippingNoticeMobile || {}), jQuery);
